import { useInvalidateUseGetAutopilotTasksForCampaign } from '@urbanx/agx.activities.client'
import { useStaffUpdateLaunchDateForCampaign } from '@urbanx/agx.campaigns.client'
import { JSX } from 'react'
import { AwaitingAgentApprovalBlocker } from './AwaitingAgentApprovalBlocker'

interface LaunchApprovalBlockerProps {
  campaignId: string
  contractId?: string | undefined
  onTasksInvalidated?: () => void | Promise<void>
}

export const LaunchApprovalBlocker = ({
  campaignId,
  contractId,
  onTasksInvalidated,
}: LaunchApprovalBlockerProps): JSX.Element => {
  const invalidateTasks = useInvalidateUseGetAutopilotTasksForCampaign()

  const refreshTasks = () => {
    if (onTasksInvalidated) return onTasksInvalidated()

    return invalidateTasks(campaignId, contractId)
  }

  const refreshTasksAfterApproval = async () => {
    await refreshTasks()
    await new Promise((resolve) => setTimeout(resolve, 1000))
    await refreshTasks()
  }

  const {
    staffUpdateLaunchDateForCampaign,
    staffUpdateLaunchDateForCampaignPending,
  } = useStaffUpdateLaunchDateForCampaign({
    onSuccess: async () => {
      await refreshTasksAfterApproval()
    },
    onError: () => undefined,
  })

  const onApprovalReceived = () => {
    if (
      !staffUpdateLaunchDateForCampaign ||
      staffUpdateLaunchDateForCampaignPending
    )
      return

    staffUpdateLaunchDateForCampaign({
      campaignId,
      hasAgentApproval: true,
    })
  }

  return (
    <AwaitingAgentApprovalBlocker
      isApprovalPending={staffUpdateLaunchDateForCampaignPending}
      onApprovalReceived={onApprovalReceived}
    />
  )
}
